module.exports = __webpack_public_path__ + "static/media/p4_img3.67ff25ea.png";